import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Wordmark } from "../components/Brand";
import { apiError } from "../lib/api";
import { MailCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setDone(true);
    } catch (err) { setError(apiError(err, "Something went wrong. Please try again.")); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-canvas flex items-center justify-center p-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="mb-8"><Wordmark size="text-2xl" />
          <div className="mt-1 text-[11px] font-bold uppercase tracking-[0.2em] text-[#78716C]">Operations Hub — Password reset</div></div>
        <div className="card p-8 space-y-5 fade-up">
          {done ? (
            <div className="text-center space-y-4" data-testid="forgot-sent">
              <MailCheck size={36} className="mx-auto text-[#4A7C59]" />
              <h1 className="font-serif font-bold text-xl text-navy">Check your email</h1>
              <p className="text-sm text-[#57534E]">If that email is registered, a reset link has been sent. It expires in 1 hour and can be used once.</p>
              <Link to="/login" className="btn-outline w-full" data-testid="forgot-back-login">Back to sign in</Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
              <div>
                <h1 className="font-serif font-bold text-xl text-navy">Reset your password</h1>
                <p className="text-sm text-[#57534E] mt-1">Enter your CKingEducation email and we'll email you a secure reset link.</p>
              </div>
              <div><label className="label" htmlFor="forgot-email">Email</label>
                <input id="forgot-email" type="email" required className="input" value={email}
                  data-testid="forgot-email-input" onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@ckinged.com" autoComplete="email" /></div>
              {error && <div className="rounded-lg border border-[#FCA5A5] bg-[#FEF2F2] px-4 py-3 text-sm font-bold text-[#991B1B]" data-testid="forgot-error">{error}</div>}
              <button className="btn-primary w-full" disabled={busy} data-testid="forgot-submit-button">{busy ? "Sending…" : "Send reset link"}</button>
              <Link to="/login" className="block text-center text-xs font-bold text-terracotta hover:underline" data-testid="forgot-back-link">Back to sign in</Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
